import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { StyledFormControl } from './MultipleSelect.styles';

interface MultipleSelectProps {
  label?: string;
  options: { id: number; name: string }[];
  selectedValues: string[];
  onChange: (selected: string[]) => void;
}

const MultipleSelect: React.FC<MultipleSelectProps> = ({ label, options, selectedValues, onChange }) => {
  return (
    <StyledFormControl fullWidth>
      <Autocomplete
        multiple
        options={options.map(option => option.name)}
        value={selectedValues}
        onChange={(_, newValue) => onChange(newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder="Почніть вводити для пошуку..."
          />
        )}
        noOptionsText="Нічого не знайдено"
        disableCloseOnSelect
        limitTags={3}
      />
    </StyledFormControl>
  );
};

export default MultipleSelect;
